<template>
  <v-app>
    <Toast />
    <confirm-cancel></confirm-cancel>
    <quick-unit-search ref="quickSearch" />

    <!--Show the main site once the user is logged in-->
    <template v-if="user">
      <v-navigation-drawer app v-model="drawer" :mini-variant="mini" hide-overlay stateless width="205">
        <v-layout column fill-height v-bind:class="{ 'non-production-environment': application.environment !== 'Production' }">
          <v-list dense>
            <v-list-item @click.stop="mini = !mini">
              <v-list-item-avatar color="secondary">
                <v-icon color="white" v-if="mini">menu</v-icon>
                <v-icon color="white" v-else>menu_open</v-icon>
              </v-list-item-avatar>

              <v-list-item-title>GateKeeper</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list dense>
            <v-list-item :to="{ name: 'home' }" exact>
              <v-list-item-action>
                <v-icon medium>home</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Home</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'calendar' }">
              <v-list-item-action>
                <v-icon medium>event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Calendar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'defects' }" v-if="showDefects">
              <v-list-item-action>
                <v-icon medium>build</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Defects</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'units' }">
              <v-list-item-action>
                <v-icon medium>local_shipping</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Units</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'containers' }">
              <v-list-item-action>
                <v-icon medium>shopping_basket</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Containers</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'campaigns' }">
              <v-list-item-action>
                <v-icon medium>departure_board</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Campaigns</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'reports' }">
              <v-list-item-action>
                <v-icon medium>library_books</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Reports</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'nhvas-reports' }" v-if="showDefects">
              <v-list-item-action>
                <v-icon medium>assessment</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>NHVAS Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'user-announcements' }">
              <v-list-item-action>
                <v-icon medium>notifications_active</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span>Announcements</span>
                  <span v-if="unseenTotal > 0">&nbsp;[{{ this.unseenTotal }}]</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-menu offset-x v-if="userIsFleetManager">
              <template v-slot:activator="{ on }">
                <v-list dense>
                  <v-list-item v-on="on">
                    <v-list-item-action>
                      <v-icon medium>policy</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Admin</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <v-list dense>
                <v-list-item :to="{ name: 'configurations' }">
                  <v-list-item-action>
                    <v-icon medium>settings</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Config</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'service-requirements' }">
                  <v-list-item-action>
                    <v-icon medium>list_alt</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Service Requirements</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'container-sizes' }">
                  <v-list-item-action>
                    <v-icon medium>zoom_out_map</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Container Sizes</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'users' }">
                  <v-list-item-action>
                    <v-icon medium>people</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Users</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'garages' }" v-if="userIsFleetManager">
                  <v-list-item-action>
                    <v-icon medium>store_mall_directory</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Garages</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'auditing' }" v-if="userIsFleetManager">
                  <v-list-item-action>
                    <v-icon medium>assignment_turned_in</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Auditing</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'announcements' }" v-if="userIsFleetManager">
                  <v-list-item-action>
                    <v-icon medium>notifications</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Announcements</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list>
          <v-spacer></v-spacer>

          <v-menu offset-x>
            <template v-slot:activator="{ on }">
              <v-list dense>
                <v-list-item v-on="on" v-if="user">
                  <v-list-item-avatar color="grey">
                    <UserImage />
                  </v-list-item-avatar>
                  <v-list-item-title>{{ user.displayName }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-else @click="login">
                  <v-list-item-title>Sign In</v-list-item-title>
                </v-list-item>
              </v-list>
            </template>
            <v-list>
              <v-list-item @click="logout">
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-layout>
      </v-navigation-drawer>

      <v-content>
        <router-view></router-view>
      </v-content>
      <v-footer app v-bind:class="{ 'non-production-environment-accent': application.environment !== 'Production' }">
        <span class="flex pl-2">{{ application.name }} &copy; JJ's 2023</span>
        <v-spacer></v-spacer>
        <span class="flex shrink pr-2">
          v{{ application.version }}
          <span v-if="application.environment !== 'Production'">&nbsp;({{ application.environment }})</span>
        </span>
      </v-footer>
    </template>

    <!--Show an authentication message if the user isn't logged in yet-->
    <template v-else>
      <v-container fill-height fluid>
        <v-flex xs12 class="text-center mb-5">
          <v-flex xs4 offset-xs4>
            <v-card>
              <v-container>
                <div class="text-center">
                  <div>
                    <img src="/img/logo_simple.png" style="width:150px;height:150px" alt="GateKeeper Logo" />
                  </div>
                  <h3 class="primary--text bold mb-0 app-title">Logging in to GateKeeper</h3>
                  If you are not redirected shortly<br />please contact Fleet.
                </div>
              </v-container>
            </v-card>
          </v-flex>
        </v-flex>
      </v-container>
    </template>
  </v-app>
</template>

<script>
import VueWait from 'vue-wait';
import ConfirmCancel from '@/components/ConfirmCancelDialog.vue';
import UserImage from '@/components/UserImage.vue';
import CONFIG from './config';
import { Event } from '@/plugins/bus';
import Toast from '@/components/Toast.vue';
import AnnouncementClient from '@/components/Announcements/AnnouncementClient.vue';
import QuickUnitSearch from '@/components/QuickUnitSearch.vue';

export default {
  name: 'App',
  wait: new VueWait(),
  mixins: [AnnouncementClient],
  components: {
    Toast,
    ConfirmCancel,
    UserImage,
    QuickUnitSearch
  },
  methods: {
    logout() {
      this.$authService.logout();
    },
    login() {
      this.$authService.login();
    },
    async fetchUnseenAnnouncements(options) {
      options = options || { force: false };

      if (this.fetchUnseen && !options.force) {
        return;
      }

      this.fetchUnseen = true;
      const response = await this.getUnseenAnnouncements(this.unseenAnnouncementsOptions.page, this.unseenAnnouncementsOptions.pageSize);
      this.unseen = this.unseen.concat(response.data);
      this.unseenTotal = response.total;
    },
    onUserInfoReceived() {
      this.user = this.$authService.user;
      this.fetchUnseenAnnouncements();
    },
    handleAnnouncementUpdated() {
      this.fetchUnseenAnnouncements({ force: true });
    },
    handleKeydown(event) {
      // Check if the user is typing in an input field
      const activeElement = document.activeElement;
      const isInputField = activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable;

      // Only trigger if not in an input field
      if (!isInputField && event.ctrlKey && event.altKey && event.key.toLowerCase() === 'u') {
        event.preventDefault();
        this.$refs.quickSearch.open();
      }
    }
  },
  created() {
    // Add keyboard event listener
    document.addEventListener('keydown', this.handleKeydown);
    this.$bus.$on(Event.UserInfoReceived, this.onUserInfoReceived);
    this.$bus.$on(Event.AnnouncementUpdated, this.handleAnnouncementUpdated);
    this.login();
    if (this.application.environment !== 'Production') {
      document.title = 'GK ' + [this.application.environment];
    }
  },
  destroyed() {
    this.$bus.$off(Event.UserInfoReceived, this.onUserInfoReceived);
    document.removeEventListener('keydown', this.handleKeydown);
  },
  data: () => ({
    drawer: true,
    mini: false,
    application: CONFIG.application,
    showDefects: CONFIG.featureToggles.defectsEnabled,
    user: null,
    fetchedUnseen: false,
    unseen: [],
    unseenTotal: 0,
    unseenAnnouncementsOptions: {
      page: 1,
      pageSize: 5
    }
  }),
  props: {
    source: String
  }
};
</script>

<style scoped>
.v-navigation-drawer >>> .v-list-item__title {
  overflow: unset;
  white-space: unset;
  overflow-wrap: break-word;
}

.non-production-environment {
  background-color: #8fbc8f;
}

.non-production-environment-accent {
  background-color: #3cb371;
}
</style>
<style lang="scss">
.clickable {
  cursor: pointer;
}

.selectable {
  user-select: auto !important;
}

.v-card.completed > *,
.v-list-item.completed {
  border-left: 6px solid #375738; //primary
  background-color: #eceff1 !important; //blue-grey lighten-1
}

tr.completed {
  border-left: 6px solid #375738; //primary
  background-color: #eceff1 !important; //blue-grey lighten-1
}

.v-list-item.itemWarning {
  border-left: 6px solid #f5b041;
  padding-left: 10px;
}

.v-card.sweptForward {
  border-left: 6px solid #f5b041;
}

.v-chip.sweptForward {
  border-left: 6px solid #f5b041;
}

.v-list-item.sweptForward {
  border-left: 6px solid #f5b041;
}

tr.sweptForward {
  border-left: 10px solid #f5b041;
}

tr.past-due {
  border-left: 6px solid #b71c1c;
  background-color: #ffcdd2 !important;
}

.v-list-item.past-due {
  border-left: 6px solid #b71c1c;
  background-color: #ffcdd2 !important;
}

.collapsed-heading {
  border-bottom: 1px solid #ccc;
}

.custom-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  .v-data-footer {
    border-top: 0 solid transparent !important;
  }
}
</style>
